// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city-10"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 21V4.5L13 2V21H3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M21 11H13V21H21V11Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M17 16V21M7 8.99805H7.00391V9.00195H7V8.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M13 21H3V4.5L13 2V21ZM13 21H21V11H13V21Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city-10')
export default class City10Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-10',
    }
  }
}
